import { useI18n } from '@/client/i18n/I18nContext';
import { CONTACT_SOURCES } from '@/lib/contactSource';

/** Optional «¿Cómo nos conociste?» select (never required, empty by default). */
export function ContactSourceField({
  id,
  value,
  onChange,
}: {
  id: string;
  value: string;
  onChange: (value: string) => void;
}) {
  const { t } = useI18n();
  return (
    <div className="field">
      <label htmlFor={id}>{t('form.source.label')}</label>
      <select id={id} value={value} onChange={(e) => onChange(e.target.value)}>
        <option value="">{t('form.source.placeholder')}</option>
        {CONTACT_SOURCES.map((key) => (
          <option key={key} value={key}>
            {t(`form.source.${key}`)}
          </option>
        ))}
      </select>
    </div>
  );
}
